'use client';

import { createContext } from 'react';

export const ShowcaseCopyContext = createContext<Record<string, string>>({});

/** UI labels use the page locale; illustrative generated documents retain their source content. */
export function translateShowcaseNode<T>(
  copy: Record<string, string>,
  value: T
): T | string {
  if (typeof value !== 'string') return value;
  if (copy[value]) return copy[value];
  // The reference's compound tabs keep the fictional brand name after the label.
  const separator = value.indexOf(' · ');
  if (separator > 0) {
    const label = value.slice(0, separator);
    if (copy[label]) return `${copy[label]}${value.slice(separator)}`;
  }
  return value;
}
